import { useSelector } from 'react-redux';
import { identity, get } from 'lodash';

function useModelState(model) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
  return useSelector(function (state) {
    return selector(model.__entityModel ? get(state, "entities.".concat(model.modelName)) : model.__valueListModel ? get(state, "valueLists.".concat(model.modelName)) : get(state, model.modelName));
  });
}

export default useModelState;